import * as React from 'react';
import {Location} from 'history';
import {ErrorPage, ErrorPageProps} from '>shared/components/pages/errorPage';
import {WndError} from 'wnd-react-utils/lib/errors';
import {pageChangeEffect} from '>lib/sideEffects';
import {Paragraph} from '>shared/components/typography/paragraph';
import {SELECTION_PRODUCT_NAME} from '>root/env';

const PAGE_TITLE = `${SELECTION_PRODUCT_NAME} - Error`;
interface PrivacyProps {
  location?: Location;
  error?: WndError;
}

function errorCodeToContent(errorCode: number | undefined): ErrorPageProps {
  switch (errorCode) {
    default:
      return {
        heading: 'Something Went Wrong',
        content: (
          <Paragraph>
            We ran into an unexpected problem when handling your request and logged the issue on our
            side. Please try again and let our support team know if you're unable to continue.
          </Paragraph>
        ),
      };
  }
}

export const PrivacyErrorPage: React.FC<PrivacyProps> = ({location, error}) => {
  let errorCode;
  if (error) {
    // can be provided when explicitly rendering this page
    errorCode = error.code;
  } else if (location) {
    // navigated or redirected to this page
    const queryParams = new URLSearchParams(location.search);
    const codeParam = queryParams.get('code');
    errorCode = codeParam ? Number(codeParam) : undefined;
  }

  const {heading, content} = errorCodeToContent(errorCode);

  React.useEffect(pageChangeEffect(PAGE_TITLE));

  return <ErrorPage heading={heading} content={content} />;
};
